import React from "react";
import { useTable, useSortBy, useFilters, Column } from "react-table";
import { useExportData } from "react-table-plugins";
import { CustomPagination } from "../../lib";
import { KTIcon } from "../../../../../_metronic/helpers";
import moment from "moment-jalaali";

interface Log {
  _id: string;
  userId: string;
  nationalCode: string;
  description: string;
  created_at?: string;
  status?: string;
  action?: string;
  f_name?: string;
  l_name?: string;
}

interface TableProps {
  data: {
    userLogs: Log[];
    totalRows: number;
    totalPages: number;
  };
  queryString: {
    page: number | string;
    search: string;
    numberInPage: number | string;
  };
  userId: number;
  setQueryString: (page: number) => void;
  refetch: () => void;
  numberInPage: number;
}

const FanReportLogTableUsers = ({
  data,
  queryString,
  setQueryString,
  refetch,
  numberInPage,
}: TableProps) => {

  const columns = React.useMemo<Column<Log>[]>(
    () => [
      {
        Header: <HeaderTextIcon text={"ردیف"} />,
        accessor: "_id",
        Cell: ({ row }) => (
          <span className="rowNum">
            {(Number(queryString.page) - 1) * Number(numberInPage) + row.index + 1}
          </span>
        ),
      },
      {
        Header: <HeaderTextIcon text={"کد ملی"} />,
        accessor: "nationalCode",
      },
      {
        Header: <HeaderTextIcon text={"توضیحات"} />,
        accessor: "description",
      },
      {
        Header: <HeaderTextIcon text={"تاریخ"} />,
        accessor: "created_at",
        Cell: ({ value }) => <span>{value ? moment(value).format('jYYYY/jMM/jDD HH:mm') : '-'}</span>,
      },
      {
        Header: <HeaderTextIcon text={"وضعیت"} />,
        accessor: "status",
        Cell: ({ value }) => (
          <span className={`badge badge-light-${value === '1' ? 'success' : 'danger'}`}>
            {value === '1' ? 'موفق' : 'ناموفق'}
          </span>
        ),
      },
    ],
    [queryString.page, numberInPage]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data: data.userLogs || [],
    },
    useFilters,
    useSortBy,
    useExportData
  );

  return (
    <div className={"p-c-30"}>
      <div style={{ overflow: "auto" }}>
        <table
          {...getTableProps()}
          className="table align-middle table-row-dashed fs-6 gy-5"
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center py-4">
                  اطلاعاتی یافت نشد
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end mt-5">
        <CustomPagination
          activePage={Number(queryString.page)}
          setQueryString={setQueryString}
          totalRows={data?.totalRows}
          numberInPage={numberInPage}
        />
      </div>
    </div>
  );
};

const HeaderTextIcon = ({ text }: { text: string }) => (
  <div className={"d-flex align-items-center justify-content-center gap-2"}>
    <span>{text}</span>
    <KTIcon iconName={"filter"} className={"fs-5"} />
  </div>
);

export default FanReportLogTableUsers; 